import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import translations from "../locals/translations.json";
import placeholder from "../assets/Car place holder PNG.png";

const QualitiesOfAction = ({ qualityData = [] }) => {
  const { language, translate } = useLanguage();
  const isRTL = language === "ar";

  // Do not render if no meaningful data
  const hasQualityData =
    Array.isArray(qualityData) &&
    qualityData.some(
      (q) => q && (q.title?.trim() || q.description?.trim() || q.icon)
    );

  if (!hasQualityData) return null;

  return (
    <>
      <section className='py-16 '>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <h2
            className='text-4xl font-bold text-center mb-4'
            dir={isRTL ? "rtl" : "ltr"}
          >
            {translations[language].sectionHeadings.qualitiesOf}{" "}
            <span className='text-primary'>
              {translations[language].sectionHeadings.auction}
            </span>
          </h2>
          <p className='justify-center text-center text-[16px] mb-8'>
            {translate("qualities.description")}
          </p>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12'>
            {qualityData.map((quality, index) => (
              <div key={index} className='text-left'>
                <div className='w-16 h-16 bg-transparent rounded-full flex items-center justify-center mb-4 overflow-hidden'>
                  <img
                    src={quality.icon || placeholder}
                    alt={quality.title || "quality-icon"}
                    className='w-full h-full object-cover'
                  />
                </div>
                {quality.title?.trim() && (
                  <h3 className='text-[20px] text-[#050B20] font-bold mb-4'>
                    {quality.title}
                  </h3>
                )}
                {quality.description?.trim() && (
                  <div
                    className='text-[15px] text-[#050B20] leading-[27.75px] text-gray-600 mb-6 text-left'
                    dir={isRTL ? "rtl" : "ltr"}
                    dangerouslySetInnerHTML={{
                      __html: quality.description,
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default QualitiesOfAction;
